<template>
  <div>
    <h1 class="text-center pt-5">Delivery labels for sample products</h1>
    <v-progress-circular
      v-if="isLoading"
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="centered"
    ></v-progress-circular>
    <div v-else>
      <div class="row pt-5">
        <div class="col-4">
          <BrandDropdown
            v-model="brandSelected"
            @setBrand="setBrand"
            @setBrands="setBrands"
            class="control"
          ></BrandDropdown>
        </div>
        <div class="col-4">
          <label for="sampleProductSelected">Sample product</label>
          <div v-if="isSampleProductLoading" class="text-center pt-3">
            <FileLoading />
          </div>
          <multiselect
            v-else
            id="sampleProductSelected"
            v-model="sampleProductSelected"
            :options="sampleProductOptions"
            label="text"
            track-by="id"
            @input="setSampleProduct"
            class="control"
          >
          </multiselect>
          <div v-if="isSubmit && error.errorId" class="text-error">
            {{ error.errorId.message }}
          </div>
        </div>
        <div class="col-4" v-show="sampleProductSelected">
          <label for="totalRegistered">Total registered</label>
          <div v-if="isTotalRegisteredLoading" class="text-center pt-3">
            <FileLoading />
          </div>
          <input
            v-else
            id="totalRegistered"
            type="text"
            v-model="totalRegistered"
            class="form-control control"
            disabled="disabled"
          />
        </div>
      </div>
      <div class="row" v-show="sampleProductSelected">
        <div class="col-4">
          <label for="firstRedemptionDate">First redemption date</label>
          <div v-if="isTotalRegisteredLoading" class="text-center pt-3">
            <FileLoading />
          </div>
          <input
            v-else
            id="firstRedemptionDate"
            type="text"
            v-model="firstRedemptionDate"
            class="form-control control redemption-date-text"
            disabled="disabled"
          />
        </div>
        <div class="col-4">
          <label for="lastRedemptionDate">Last redemption date</label>
          <div v-if="isTotalRegisteredLoading" class="text-center pt-3">
            <FileLoading />
          </div>
          <input
            v-else
            id="lastRedemptionDate"
            type="text"
            v-model="lastRedemptionDate"
            class="form-control control redemption-date-text"
            disabled="disabled"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex flex-row">
            <div class="form-check form-check-inline pr-5">
              <input
                class="form-check-input"
                type="radio"
                name="filterType"
                id="byOffset"
                value="offset"
                v-model="filterType"
              />
              <label class="form-check-label" for="byOffset">By offset</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="filterType"
                id="byDateTime"
                value="dateTime"
                v-model="filterType"
              />
              <label class="form-check-label" for="byDateTime"
                >By redemption date</label
              >
            </div>
          </div>
          <div v-if="isSubmit && error.errorFilterType" class="text-error">
            {{ error.errorFilterType.message }}
          </div>
        </div>
      </div>
      <div class="row" v-show="filterType === 'dateTime'">
        <div class="col-4">
          <label for="redemptionDatetimeFrom">Redemption date from</label>
          <VueCtkDateTimePicker
            id="redemptionDatetimeFrom"
            v-model="redemptionDatetimeFrom"
            format="DD/MM/YYYY HH:mm:ss"
            formatted="DD MMM YYYY HH:mm:ss"
            :noHeader="true"
            :noLabel="true"
            class="control"
            @input="changeStartDate($event)"
          />
          <div
            v-if="isSubmit && error.errorRedemptionDatetimeFrom"
            class="text-error"
          >
            {{ error.errorRedemptionDatetimeFrom.message }}
          </div>
        </div>
        <div class="col-4">
          <label for="redemptionDatetimeTo">Redemption date to</label>
          <VueCtkDateTimePicker
            id="redemptionDatetimeTo"
            v-model="redemptionDatetimeTo"
            format="DD/MM/YYYY HH:mm:ss"
            formatted="DD MMM YYYY HH:mm:ss"
            :noHeader="true"
            :noLabel="true"
            class="control"
            :min-date="minDate"
          />
          <div
            v-if="isSubmit && error.errorRedemptionDatetimeTo"
            class="text-error"
          >
            {{ error.errorRedemptionDatetimeTo.message }}
          </div>
        </div>
      </div>
      <div class="row" v-show="filterType === 'offset'">
        <div class="col-4">
          <label for="offsetFrom">Offset from</label>
          <NumberInput input-id="offsetFrom"
                       v-model.number="offsetFrom"
                       dynamic-class="control"/>
          <div v-if="isSubmit && error.errorOffsetFrom" class="text-error">
            {{ error.errorOffsetFrom.message }}
          </div>
        </div>
        <div class="col-4">
          <label for="offsetTo">Offset to</label>
          <NumberInput input-id="offsetTo"
                       v-model.number="offsetTo"
                       dynamic-class="control"/>
          <div v-if="isSubmit && error.errorOffsetTo" class="text-error">
            {{ error.errorOffsetTo.message }}
          </div>
        </div>
      </div>
      <div class="row text-right">
        <div class="col align-self-center">
          <button
            class="btn btn-outline-primary"
            style="width: 100%; max-width: 131px"
            @click="getDeliveryLabelPdfFile"
          >
            OK
          </button>
        </div>
      </div>
      <div class="row" v-show="fileUrl">
        <div class="col">
          <a
            href="#"
            target="_blank"
            @click.prevent="downloadDeliveryLabelPdfFile"
            >Download label file</a
          >
        </div>
      </div>

      <v-dialog v-model="showDialog" width="500" persistent>
        <div class="content-dialog">
          <h3 class="p-5">{{ message }}</h3>
          <div class="text-center">
            <button class="btn-back" @click="showDialog = false">ปิด</button>
          </div>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import BrandDropdown from "components/Brand/BrandDropdown.vue";
import PrivilegeService from "services/api/privilege.service";
import SampleProductService from "services/api/sampleProduct.service";
import moment from "moment/moment";
import FileLoading from "components/Loading/FileLoading.vue";
import NumberInput from "components/NumberInput/NumberInput.vue";

export default {
  components: {NumberInput, FileLoading, BrandDropdown},
  data() {
    return {
      isLoading: false,
      isSampleProductLoading: false,
      isTotalRegisteredLoading: false,
      isSubmit: false,
      message: "",
      showDialog: false,
      brandSelected: null,
      sampleProductSelected: null,
      sampleProductOptions: [],
      totalRegistered: null,
      firstRedemptionDate: null,
      lastRedemptionDate: null,
      filterType: "offset",
      redemptionDatetimeFrom: null,
      redemptionDatetimeTo: null,
      minDate: null,
      offsetFrom: 1,
      offsetTo: null,
      fileUrl: null,
      error: {
        errorId: null,
        errorFilterType: null,
        errorRedemptionDatetimeFrom: null,
        errorRedemptionDatetimeTo: null,
        errorOffsetFrom: null,
        errorOffsetTo: null,
      },
    };
  },
  methods: {
    async getSampleProducts() {
      this.isSampleProductLoading = true;
      const params = {
        brandCode: this.brandSelected?.id,
        privilegeType: "SAMPLE_PRODUCT",
      };
      await PrivilegeService.getListPrivileges(params)
        .then((res) => {
          this.isSampleProductLoading = false;
          const data = res.data;
          this.sampleProductOptions = data.privileges.map((p) => {
            return {
              id: p.id,
              text: `(${p.id}) ${p.name}`,
            };
          });

          if (this.$route.query.sampleProductId) {
            this.sampleProductOptions.forEach((product) => {
              if (product.id === +this.$route.query.sampleProductId) {
                this.sampleProductSelected = product;
                this.getTotalRegisteredAndRedemptionDate();
              }
            });
          }
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    async getTotalRegisteredAndRedemptionDate() {
      this.isTotalRegisteredLoading = true;
      await PrivilegeService.getDetailPrivilege(this.sampleProductSelected.id)
        .then((res) => {
          this.isTotalRegisteredLoading = false;
          const data = res.data?.privilege;
          this.totalRegistered = data.totalDelivery;
          this.offsetTo = data.totalDelivery;
          this.firstRedemptionDate = this.getFormattedDateTime(
            data.firstRedemptionDate
          );
          this.lastRedemptionDate = this.getFormattedDateTime(
            data.lastRedemptionDate
          );
          this.redemptionDatetimeFrom = this.getFormatDateTimeForDatePicker(
            data.firstRedemptionDate
          );
          this.redemptionDatetimeTo = this.getFormatDateTimeForDatePicker(
            data.lastRedemptionDate
          );
        })
        .catch((err) => {
          this.isTotalRegisteredLoading = false;
          console.log("Error: ", err);
        });
    },
    async getDeliveryLabelPdfFile() {
      this.isSubmit = true;
      this.isLoading = true;
      await this.$router.replace({ query: null });
      this.resetErrorText();
      const params = {
        samplePrivilegeId: this.sampleProductSelected?.id,
        filterType: this.filterType,
      };

      let paramsWithFilterOption;
      if (this.filterType === "offset") {
        paramsWithFilterOption = {
          ...params,
          offsetFrom: this.offsetFrom,
          offsetTo: this.offsetTo,
        };
      } else {
        paramsWithFilterOption = {
          ...params,
          redemptionDatetimeFrom: this.redemptionDatetimeFrom || null,
          redemptionDatetimeTo: this.redemptionDatetimeTo || null,
        };
      }
      await SampleProductService.getDeliveryLabels(paramsWithFilterOption)
        .then((res) => {
          this.isLoading = false;
          const data = res.data;
          this.fileUrl = data.fileUrl;
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("Error: ", err.response);
          const errorData = err.response?.data;
          if (errorData.errors?.length > 0) {
            this.setErrorText(errorData.errors);
            return;
          }
          if (errorData?.message) {
            this.showDialog = true;
            this.message = errorData.message;
          }
        });
    },
    setBrand(brand) {
      this.brandSelected = brand || "";
      this.sampleProductSelected = null;
      this.getSampleProducts();
      this.totalRegistered = null;
    },
    setBrands(brands) {
      brands.forEach((brand) => {
        if (brand.id === this.$route.query.brandCode) {
          this.brandSelected = brand;
        }
      });
    },
    setSampleProduct() {
      this.getTotalRegisteredAndRedemptionDate();
    },
    changeStartDate(val) {
      this.minDate = this.getISOFormatDate(val);
      if (this.minDate > this.getISOFormatDate(this.redemptionDatetimeTo)) {
        this.redemptionDatetimeTo = null;
      }
    },
    getISOFormatDate(val) {
      return moment(val, "DD/MM/YYYY HH:mm:ss").toISOString();
    },
    getFormatDateTimeForDatePicker(dateTimeVal) {
      return dateTimeVal
        ? moment(dateTimeVal).format("DD/MM/YYYY HH:mm:ss")
        : null;
    },
    getFormattedDateTime(dateTimeVal) {
      return dateTimeVal
        ? moment(dateTimeVal).format("DD MMM YYYY HH:mm:ss")
        : null;
    },
    downloadDeliveryLabelPdfFile() {
      try {
        window.open(this.fileUrl);
      } catch (error) {
        console.log("Error: ", error);
      }
    },
    setErrorText(errors) {
      this.error.errorId = errors.find((e) => e.fieldName === "id");
      this.error.errorFilterType = errors.find(
        (e) => e.fieldName === "filterType"
      );
      this.error.errorRedemptionDatetimeFrom = errors.find(
        (e) => e.fieldName === "redemptionDatetimeFrom"
      );
      this.error.errorRedemptionDatetimeTo = errors.find(
        (e) => e.fieldName === "redemptionDatetimeTo"
      );
      this.error.errorOffsetFrom = errors.find(
        (e) => e.fieldName === "offsetFrom"
      );
      this.error.errorOffsetTo = errors.find((e) => e.fieldName === "offsetTo");
    },
    resetErrorText() {
      this.error.errorId = null;
      this.error.errorFilterType = null;
      this.error.errorRedemptionDatetimeFrom = null;
      this.error.errorRedemptionDatetimeTo = null;
      this.error.errorOffsetFrom = null;
      this.error.errorOffsetTo = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  margin: 0.6rem 0;
}

.redemption-date-text {
  font-size: 14px;
}
</style>
